import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import Vue from 'vue'
import Vuex from 'vuex'
// eslint-disable-next-line import/no-cycle
import userStoreModule from '@/store/userStoreModule'
import app from './app'
// eslint-disable-next-line import/no-cycle
import assistanceStoreModule from '@/store/assistanceStoreModule'
import settingsStore from '@/store/settingsStore'
import globalStoreModule from '@/store/globalStoreModule'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    appConfig: appConfigStoreModule,
    app,
    user: userStoreModule,
    assistance: assistanceStoreModule,
    global: globalStoreModule,
    settings: settingsStore,
  },
})
